/**
 * Coerenza selezione Azienda ⇄ Dipendente (v0.99.30-c2 fix).
 *
 * Il bug: molte pagine facevano `setEmployeeId(list[0].id)` selezionando il
 * primo dipendente indipendentemente dall'azienda corrente, creando coppie
 * inconsistenti. Questo helper centralizza la regola:
 *
 *   1. Non si seleziona MAI un dipendente in autonomia.
 *      L'utente deve scegliere prima l'azienda, poi il dipendente.
 *   2. Se `employeeId` non è presente nella lista dei dipendenti dell'azienda
 *      corrente → reset a null.
 *   3. Nessuna scelta automatica avviene salvo esplicita richiamata da parte
 *      del chiamante (opt-in).
 *
 * Uso tipico:
 *   const nextEmp = reconcileEmployeeWithCompany(employeeId, employees);
 *   if (nextEmp !== employeeId) setEmployeeId(nextEmp);
 */

/**
 * Ritorna l'employeeId da usare dopo un cambio di azienda/lista dipendenti.
 * @param {string|null} currentEmployeeId
 * @param {Array<{id:string, company_id?:string}>} employeesOfCompany
 * @returns {string|null} - `currentEmployeeId` se ancora valido, altrimenti null.
 */
export function reconcileEmployeeWithCompany(
  currentEmployeeId,
  employeesOfCompany,
  { autoSelectFirst = false } = {},
) {
  if (!Array.isArray(employeesOfCompany) || employeesOfCompany.length === 0) return null;
  const found = currentEmployeeId
    && employeesOfCompany.some((e) => e && e.id === currentEmployeeId);
  if (found) return currentEmployeeId;
  return autoSelectFirst ? (employeesOfCompany[0]?.id || null) : null;
}

/**
 * Valida che il dipendente appartenga all'azienda specificata.
 * Utile per validare valori arrivati da URL / localStorage / query param.
 * @returns {boolean}
 */
export function belongsToCompany(employeeId, companyId, employeesList) {
  if (!employeeId || !companyId) return false;
  if (!Array.isArray(employeesList)) return false;
  return employeesList.some((e) => e && e.id === employeeId && e.company_id === companyId);
}
